import React from 'react';
import { BannerComponent, GlobalBannerComponent } from '../../../components';

const CommonBannerComponent = ({
    bannerState, bannerProps, bannerType, continueAction
}) => {
    return (
    <div>
        {bannerState === 'global' && <GlobalBannerComponent bannerProps={bannerProps} />}
        {bannerState === 'inline' && <BannerComponent bannerType={bannerType} continueAction={continueAction} />}
    </div>
    );
};


export default CommonBannerComponent;